export default "__VITE_ASSET__DLuJRdWz__"